import ModelMelhousServices from "./ModelMelhousServices";
import ModelMelhousGallery from "./ModelMelhousGalleryAreas";
import ModelMelhousSpecialServices from "./ModelMelhousSpecialServices";
import ModelMelhousOtherServices from "./ModelMelhousOtherServices";
import readOnlyLayout from "../helpers/readOnlyLayout";

function getView() {
  return readOnlyLayout({
    model: "melhous",
    activeSearch: false,
    domain: [],
    softDomain: [["id", ">", 0]],
    fields: {
      title: { type: "char", searchable: true },
      banner: { type: "char" },
      desc: { type: "text" },
      address: { type: "char" },
      url: { type: "char" },
      wifi: { type: "char" },
      wifi_pass: { type: "char" },
      phone: { type: "char" },
      reception_phone: { type: "char" },
      reception_phone2: { type: "char" },
      reception_phone3: { type: "char" },
      breakfast_start: { type: "time" },
      breakfast_end: { type: "time" },
      lunch_start: { type: "time" },
      lunch_end: { type: "time" },
      meal_start: { type: "time" },
      meal_end: { type: "time" },
      check_in: { type: "time" },
      check_out: { type: "time" },
      title_gallery: { type: "char" },
      desc_gallery: { type: "char" },
      services: {
        type: "one2many",
        model: "melhous.service",
        layout: ModelMelhousServices.ctxView(),
      },
      special_services: {
        type: "one2many",
        model: "melhous.special_services",
        layout: ModelMelhousSpecialServices.ctxView(),
      },
      other_services: {
        type: "one2many",
        model: "melhous.other_services",
        layout: ModelMelhousOtherServices.ctxView(),
      },
      gallery_areas: {
        type: "one2many",
        model: "melhous.gallery_areas",
        layout: ModelMelhousGallery.ctxView(),
      },
    },
    list: [{ name: "title", width: "30%" }, { name: "desc" }],
    form: [
      { name: "title" },
      { name: "banner" },
      { name: "desc", colSpan: "md:col-span-2" },
      { name: "check_in" },
      { name: "check_out" },
      { name: "address" },
      { name: "url" },
      { name: "wifi" },
      { name: "wifi_pass" },
      { name: "phone" },
      { name: "reception_phone" },
      { name: "reception_phone2" },
      { name: "reception_phone3" },
      { name: "breakfast_start" },
      { name: "breakfast_end" },
      { name: "lunch_start" },
      { name: "lunch_end" },
      { name: "meal_start" },
      { name: "meal_end" },
      { name: "services" },
      { name: "special_services" },
      { name: "other_services" },
      { name: "title_gallery" },
      { name: "desc_gallery" },
      { name: "gallery_areas" },
    ],
  });
}

export default { ctxView: getView };
